import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';

const AccountIdFilter = <AutoCompleteFilter
    label='filters.components.accountId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    } }
    reference='accounts'
    optionValue='id'
    searchBy='name'
    source='account_id'
/>;

export default AccountIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/AccountIdFilter.js